import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';
import { FormGroup } from '@angular/forms';
import { users } from '../../../../interfaces/users';
import { ExcelExportService } from '../../../../services/excel-export.service';
import { MatTableDataSource } from '@angular/material/table';
import { UserService } from '../../../../services/user';
import { Observable } from 'rxjs/internal/Observable';
import { map } from 'rxjs';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { ClientsService } from '../../../../services/clients.service';
import { DoctorsService } from '../../../../services/doctors';
import { DeviceDetectorService } from '../../../../services/device-detector.service';

@Component({
  selector: 'app-alldoctors',
  templateUrl: './alldoctors.component.html',
  styleUrl: './alldoctors.component.scss'
})
export class AlldoctorsComponent implements OnInit {
  @Input() isProfile: string = '';

  allData: any[] = [];
  userimage!: string;
  userData!: users;
  username!: string;
  userPhone = '';
  userName = '';
  profile!: boolean;
  userfirstname = '';
  userFacebook = '';
  userInstgram = '';
  userTiktok = '';

  private readonly desktopColumns: string[] = [
    'doctor_image',
    'name',
    'mobile',
    'specialty',
    'has_master',
    'has_phd',
    'files',
    'visa',
    'transfer_of_sponsorship',
    'fellowship',
    'classification_status',
    'ksa_experience',
    'residence_place',
    'birth_place',
    'birth_date',
    'has_dataflow',
    'call',
    'chat',
    'options'
  ];

  private readonly mobileColumns: string[] = [
    'doctor_image',
    'name',
    'mobile',
    'specialty',
    'birth_date',
    'files',
    'options'
  ];

  displayedColumns: string[] = [...this.desktopColumns];

  contentReady = true;
  noData = false;
  showPopUp = false;
  showRejectPopUp = false;
  orderchange!: FormGroup;
  reason = '';
  orderId!: any;
  statuslist: any;
  clear = false;
  accountType!: string;
  isAdmin!: boolean;
  isSubAdmin!: boolean;
  stockTotal!: any;
  totalItems = 0;
  searched = false;
  isMobile = false;
  showoptions = false;
  searchKey = '';
  isAr = localStorage.getItem('language') === 'ar';
  pageSize = 10;
  currentPage = 1;

  dataSource: MatTableDataSource<any>;

  isAdmin$: Observable<boolean> = this._userService.getAccountType().pipe(
    map(() => this.accountType === '1')
  );

  isSubAdmin$: Observable<boolean> = this._userService.getAccountType().pipe(
    map(() => this.accountType === '6')
  );

  @ViewChild(MatPaginator) paginator!: MatPaginator;

  constructor(
    private router: Router,
    private _clientsService: ClientsService,
    private _doctor: DoctorsService,
    private deviceService: DeviceDetectorService,
    private excelExportService: ExcelExportService,
    private _userService: UserService
  ) {
    this.dataSource = new MatTableDataSource(this.allData);
  }

  ngOnInit(): void {
    this.isMobile = this.deviceService.isMobileDevice();

    this._userService.getAccountType().subscribe({
      next: data => {
        this.accountType = data['user_type'];
        this.isAdmin = this.accountType === '1';
        this.isSubAdmin = this.accountType === '6';

        const hasPhoneAccess = Boolean(data['has_access_to_phone_numbers']);

        this.buildDisplayedColumns(hasPhoneAccess);
        this.getAllClients(this.pageSize, 1, true);
      },
      error: error => {
        console.error(error);
        this.contentReady = false;
      }
    });
  }

  search(): void {
    const key = this.searchKey?.trim();

    if (!key) {
      this.getAllClients(this.pageSize, 1, true);
      return;
    }

    this.contentReady = true;
    this.searched = true;

    this._doctor.search(key, true).subscribe({
      next: (res: any) => {
        const list = Array.isArray(res) ? res : res?.data || [];

        this.allData = list;
        this.totalItems = list.length;
        this.dataSource = new MatTableDataSource(this.allData);

        this.contentReady = false;
        this.noData = this.allData.length === 0;
      },
      error: error => {
        console.error(error);
        this.contentReady = false;
      }
    });
  }

  getAllClients(perpage: any, page: any, isdoctor: any): void {
    this.contentReady = true;
    this.searched = false;
    this.currentPage = page;
    this.pageSize = perpage;

    this._doctor.getAll(perpage, page, isdoctor).subscribe({
      next: (data: any) => {
        this.allData = data?.data || [];
        this.stockTotal = data?.last_page || 0;
        this.totalItems = data?.total || this.allData.length;

        this.dataSource = new MatTableDataSource(this.allData);

        this.contentReady = false;
        this.noData = this.allData.length === 0;
      },
      error: error => {
        console.error(error);
        this.contentReady = false;
      }
    });
  }

  onPaginateChange(event: PageEvent): void {
    const newPage = event.pageIndex + 1;
    const newPageSize = event.pageSize || this.pageSize;

    this.getAllClients(newPageSize, newPage, true);
  }

  applyFilter(event: Event): void {
    const filterValue = (event.target as HTMLInputElement).value.trim().toLowerCase();
    this.dataSource.filter = filterValue;
  }

  exportToExcel(): void {
    this.excelExportService.exportToExcel('Clients', '_doctor', ['actions']);
  }

  delete(id: any): void {
    Swal.fire({
      title: this.isAr ? 'متأكد؟؟' : 'Are You Sure?',
      showCancelButton: true,
      confirmButtonText: this.isAr ? 'نعم' : 'YES',
      cancelButtonText: this.isAr ? 'لا' : 'no'
    }).then(result => {
      if (result.isConfirmed) {
        this.contentReady = true;

        this._doctor.delete(id).subscribe({
          next: () => {
            this.getAllClients(this.pageSize, this.currentPage, true);
          },
          error: err => {
            console.log(err);
            this.contentReady = false;
          }
        });
      }
    });
  }

  edit(itemobj: any): void {
    this.router.navigate(['/createdoctor'], { queryParams: itemobj });
  }

  call(phone: any): void {
    if (!phone) return;
    window.open('tel:+' + phone, '_blank');
  }

  chat(phone: any): void {
    if (!phone) return;
    window.open('https://api.whatsapp.com/send?phone=2' + phone, '_blank');
  }

  formatDate(date: string): string {
    if (!date) return '-';

    const d = new Date(date);

    if (Number.isNaN(d.getTime())) {
      return '-';
    }

    const day = d.getDate().toString().padStart(2, '0');
    const month = (d.getMonth() + 1).toString().padStart(2, '0');
    const year = d.getFullYear().toString().slice(2);

    return `${day}-${month}-${year}`;
  }

  formatFullDate(date: string): string {
    if (!date) return '-';

    const value = String(date).split('T')[0];
    const parts = value.split('-');

    if (parts.length !== 3) return '-';

    const [year, month, day] = parts;

    return `${day}-${month}-${year}`;
  }

  isTruthy(value: any): boolean {
    return value === true || value === 1 || value === '1' || value === 'true';
  }

  getDoctorImage(item: any): string {
    const raw =
      item?.doctor_image ||
      item?.doctor_image_url ||
      item?.image ||
      item?.image_url ||
      item?.profile_image ||
      item?.photo;

    return this.fixStorageUrl(raw);
  }

  getCvUrl(item: any): string {
    const raw =
      item?.cv ||
      item?.cv_url ||
      item?.doctor_cv ||
      item?.doctor_cv_url ||
      item?.resume ||
      item?.resume_url;

    return this.fixStorageUrl(raw);
  }

  getCertificates(item: any): any[] {
    const raw =
      item?.certificates ||
      item?.doctor_certificates ||
      item?.certificate_files ||
      item?.files ||
      [];

    if (Array.isArray(raw)) {
      return raw.filter(cert => this.getCertificateUrl(cert));
    }

    if (typeof raw === 'string') {
      const value = raw.trim();

      if (!value || value === 'null' || value === '[]') {
        return [];
      }

      try {
        const parsed = JSON.parse(value);

        if (Array.isArray(parsed)) {
          return parsed.filter(cert => this.getCertificateUrl(cert));
        }
      } catch {
        return value
          .split(',')
          .map(item => item.trim())
          .filter(Boolean);
      }

      return [value];
    }

    return [];
  }

  getCertificateUrl(cert: any): string {
    const raw =
      cert?.url ||
      cert?.file_url ||
      cert?.path ||
      cert?.file ||
      cert?.certificate ||
      cert;

    return this.fixStorageUrl(raw);
  }

  private buildDisplayedColumns(hasPhoneAccess: boolean): void {
    let columns = this.isMobile
      ? [...this.mobileColumns]
      : [...this.desktopColumns];

    if (!hasPhoneAccess) {
      const colsToRemove = ['mobile', 'call', 'chat'];
      columns = columns.filter(col => !colsToRemove.includes(col));
    } else if (!this.isMobile) {
      columns.push('add_by', 'editor');
    }

    this.displayedColumns = columns;
  }

  private readonly backendStorageBaseUrl =
    'https://backendtest.blueboxpet.com/storage/app/public';

  fixStorageUrl(url: any): string {
    if (!url) return '';

    let path = String(url).trim();

    if (!path || path === 'null' || path === 'undefined') return '';

    path = path.replace(/^https?:\/\/backendtest\.blueboxpet\.com\//i, '');

    path = path.replace(/^\/+/, '');

    path = path
      .replace(/^storage\/app\/public\//, '')
      .replace(/^storage\/app\//, '')
      .replace(/^storage\/public\//, '')
      .replace(/^storage\//, '')
      .replace(/^app\/public\//, '')
      .replace(/^public\//, '');

    return `${this.backendStorageBaseUrl}/${path}`;
  }
}